import { Booking, Leg, Passenger, Segment, Seat } from "../../state/models";

interface FindSeatArgs {
  logicalFlightId: number;
  physicalFlightId: number;
  passengerId: number;
}

export interface FindSeatData {
  segment: Segment;
  leg: Leg;
  passenger: Passenger;
  seat: Seat;
}

export function findAddedSeat( booking: Booking, args: FindSeatArgs): FindSeatData | undefined {

  if(!Array.isArray(booking?.passengers) || booking.passengers.length === 0) return;
  if(!Array.isArray(booking?.segments) || booking.segments.length === 0) return;

  const { passengers, segments } = booking;
  const { logicalFlightId, physicalFlightId, passengerId } = args;

  const passenger = passengers.find(p => p.id === passengerId);
  if(!passenger) return;

  const segment = segments.find(s => s.logicalFlightId === logicalFlightId);
  if(!segment) return;

  const leg = segment.legs.find(l => l.physicalFlightId === physicalFlightId);
  if(!leg) return;

  const customer = leg.customers.find(p => p.passengerId === passengerId);
  if(!customer?.seat?.serviceCode) return;

  return { segment, leg, passenger, seat: customer.seat };
}